'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { Container, Title, Subtitle, Illustration } from './elements';
import { Button } from '../Button';
import { Link } from '../Link';
import { Animation } from './Animation';
import { Action } from '../Action';
export const assetsUrl = 'https://assets.asurion-ui.my.asurion53.com';
export const ErrorPage = /*#__PURE__*/forwardRef(({
  code,
  title = "Something's not right",
  subtitle = "That's entirely our fault.\nPlease try again soon and everything should be back to normal.",
  actionLabel = 'Go to homepage',
  button = {},
  link = {},
  action,
  illustration = /*#__PURE__*/React.createElement(Illustration, {
    src: `${assetsUrl}/images/astro.png`,
    role: "presentation"
  }),
  ...rest
}, fRef) => {
  if (code === '404') {
    title = 'This page is missing';
    subtitle = "It may have been moved or deleted.\n But don't worry, we can fix almost anything.";
    illustration = /*#__PURE__*/React.createElement(Animation, {
      animationSrc: `${assetsUrl}/images/illustrations/error/404-animation/`,
      animationFrames: 12,
      transitionDuration: 250,
      errorNumberSrc: `${assetsUrl}/images/illustrations/error/code/404.svg`,
      imageSrc: `${assetsUrl}/images/phone.png`,
      imgAfterIdx: 7,
      altText: "404"
    });
  }
  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: fRef
  }, rest, {
    "data-aui": "error-page"
  }), /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(Subtitle, null, subtitle), illustration, link.href ? /*#__PURE__*/React.createElement(Link, _extends({
    variant: "button",
    href: link.href
  }, link), actionLabel) : Object.keys(button).length ? /*#__PURE__*/React.createElement(Button, button, actionLabel) : /*#__PURE__*/React.createElement(Action, action, actionLabel));
});